import { Module } from '@/modules/core/app/constants/app.constants';
import { MarketplaceRouteConfig } from '@/modules/to/marketplace/MarketplaceRouteConfig';

export const router = MarketplaceRouteConfig.factory(
  [
    {
      // eslint-disable-next-line tap/no-raw-text-js
      path: '/welcomemarketplace',
      name: 'marketplace',
      component: () =>
        import(/* webpackChunkName: "marketplace-welcome-page" */ './pages/MarketplaceWelcome'),
    },
    {
      path: '/accountrefresh/:id',
      name: 'account-refresh',
      component: () =>
        import(
          /* webpackChunkName : "marketplace-account-refresh" */ './components/AccountRefreshPage'
        ),
    },
    {
      path: '/accountreturn/:id',
      name: 'account-return',
      component: () =>
        import(
          /* webpackChunkName : "marketplace-account-return" */ './components/AccountReturnPage'
        ),
    },
    {
      path: '/paymentredirection',
      name: 'payment-redirect',
      component: () =>
        import(
          /* webpackChunkName : "marketplace-payment-redirection" */ './components/PaymentRedirectionPage'
        ),
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: () =>
        import(
          /* webpackChunkName : "subscriptions-list-page" */ '../subscriptions/pages/SubscriptionListPage.vue'
        ),
    },
  ],
  Module.MARKETPLACE
);
